import React, {useState, useEffect, useRef , useContext } from 'react';
import { Table, Form, Input, Row, Col, Button, InputNumber, Space, Select, Modal, Popconfirm } from 'antd';
import { DeleteOutlined, FolderAddOutlined, FolderViewOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AddDecklist from './AddDecklist';
import ShowDeckColors from './ShowDeckColors';

const EditableContext = React.createContext(null);

function RankingTable(props) {
    const [dataSource, setDataSource] = useState(props.dataSource)
    const [selectedDeck, setSelectedDeck] = useState([]);
    const [modalActive, setModalActive] = useState(false);
    const { t } = useTranslation();

    // console.warn('props di rankingtable', props)
    const stage = (props.stage && props.stage.payLoad !== null ? props.stage.payLoad : {});
    const tournament = (props.tournament && props.tournament.data.payLoad !== null ? props.tournament.data.payLoad : {})
    const tournType = (tournament && tournament.type ? tournament.type.id : 0)
    const decknameOpts = (props.archetypes && props.archetypes.data && props.archetypes.data.payLoad ? props.archetypes.data.payLoad.map((arch) => <Select.Option key={arch.id} value={arch.name}>{arch.name}</Select.Option>) : [])

    function generateParticipantsCol(props) {
      let participantsCol;

      if (props.hasRights && (props.hasRights.isAdmin || props.hasRights.isReferral)) {
        participantsCol = [
          {
            title: t('columns.position'),
            dataIndex: (props.isTournament ? 'rankingPlace' : 'stagePlace'),
            key: (props.isTournament ? 'rankingPlace' : 'stagePlace'),
            editable: false,
          },
          {
            title: t('players.name'),
            dataIndex: 'playerName',
            key: 'name', 
            editable: false,
            render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
          },
          {
              title: t('decks.name'),
              dataIndex: 'deckName',
              key: 'deckName',
              editable: false,
              render: (state, record) => {
                if (record.deckId > 0 ) {
                  return (<Space> 
                        <Link to={'/decks/'+record.deckId+'/'}>
                          {record.deckName}
                        </Link>
                        <ShowDeckColors archetypes={props.archetypes} deck={record} />
                      </Space>);
                }
                // if (props.rights && (props.rights.isAdmin || props.rights.isReferral)){
                //  return (<Space> {record.deckName}<AddDecklist player={record} {...props}/></Space>);
                // }
                return (<Space> {record.deckName} </Space>);
              }
          },
          {
            title: t('players.points'),
            dataIndex: 'stagePoints',
            key: 'stagePoints',
            editable: true,
            inputType: 'number',
          },
          {
            title: t('common.actions'),
            dataIndex: 'playerId',
            key: 'playerId',
            render: (state, record) => (
                (<div>
                  { record.deckId <= 0 && (
                    <Space style={{ marginRight: '3px' }}><AddDecklist player={record} {...props} /></Space>
                  )}
                  { props.isDone === false && (
                    <Space>
                    <Popconfirm
                        title="Delete participant"
                        description="Are you sure to remove this player from event?"
                        onConfirm={(e) => {e.preventDefault(); onDeletePlayer(record)}}
                        okText="Yes"
                        cancelText="No"
                    >
                      <Button size="small" danger icon={<DeleteOutlined />}/>
                    </Popconfirm>
                  </Space> 
                  )}
                  </div>)
              )
          },
        ]
        if (props.isTournament) {
          participantsCol.splice(3,1);
        }
      } else {
        participantsCol = [
          {
            title: t('columns.position'),
            dataIndex: (props.isTournament ? 'rankingPlace' : 'stagePlace'),
            key: (props.isTournament ? 'rankingPlace' : 'stagePlace'),
            editable: false,
          },
          {
            title: t('players.name'),
            dataIndex: 'playerName',
            key: 'name', 
            editable: false,
            render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
          },
          {
              title: t('decks.name'),
              dataIndex: 'deckName',
              key: 'deckName',
              editable: false,
              render: (state, record) => {
                if (record.deckId > 0 ) {
                  return (<Space>
                        <Link to={'/decks/'+record.deckId+'/'}>
                        {record.deckName}
                        </Link>
                        <ShowDeckColors archetypes={props.archetypes} deck={record} />
                      </Space>);
                }
                // if (props.rights && (props.rights.isAdmin || props.rights.isReferral)){
                //  return (<Space> {record.deckName}<AddDecklist player={record} {...props}/></Space>);
                // }
                return (<Space> {record.deckName} </Space>);
              }
          },
          {
            title: t('players.points'),
            dataIndex: 'stagePoints',
            key: 'stagePoints',
            editable: true,
            inputType: 'number',
          }
        ]
        if (props.isTournament) {
          participantsCol.splice(3,1);
        }
      }

      return participantsCol;
    }
    
    
    // let participantsCol;
    let participantsColEdit;
    if (props.isTournament) {
      /* participantsCol = [
        {
          title: t('columns.position'),
          dataIndex: 'rankingPlace',
          key: 'place',
          editable: false,
        },
        {
          title: t('players.name'),
          dataIndex: 'playerName',
          key: 'name', 
          editable: false,
          render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
        },
        {
          title: t('decks.name'),
          dataIndex: 'deckName',
          key: 'deckName',
          editable: false,
          render: (state, record) => {
            if (record.deckId > 0 ) {
              return (<Space> {record.deckName} 
                    <Link to={'/decks/'+record.deckId+'/'}>
                      <FolderViewOutlined style={{ fontSize: '25px' }} />
                    </Link>
                  </Space>);
            }
            if (props.hasRights && (props.hasRights.isAdmin || props.hasRights.isReferral)){
              // console.warn('renderizzo adddecklist per player in pagina di tappa chiusa:', record);
              return (<Space> {record.deckName}<AddDecklist player={record} {...props}/></Space>);
            }
            return (<Space> {record.deckName} </Space>);
          }
        }
      ] */
      participantsColEdit = [
        {
          title: t('columns.position'),
          dataIndex: 'rankingPlace',
          key: 'rank',
          editable: true,
          inputType: 'number',
        },
        {
          title: t('players.name'),
          dataIndex: 'playerName',
          key: 'name', 
          editable: false,
          render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
        },
        {
          title: t('decks.name'),
          dataIndex: 'deckName',
          key: 'deckName',
          editable: true,
          inputType: 'deckSelect',
          render: (state, record) => {
            if (record.deckId > 0 ) {
              return (<Space>
                    <Link to={'/decks/'+record.deckId+'/'}>
                      {record.deckName}
                    </Link>
                    <ShowDeckColors archetypes={props.archetypes} deck={record} />
                  </Space>);
            }
            return (<Space> {record.deckName} </Space>);
          }
        }
      ]
    } else {
      participantsColEdit = [
        {
          title: t('columns.position'),
          dataIndex: 'stagePlace',
          key: 'place',
          editable: true,
          inputType: 'number',
        },
        {
          title: t('players.name'),
          dataIndex: 'playerName',
          key: 'name', 
          editable: false,
          render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
        },
        {
          title:  t('decks.name'),
          dataIndex: 'deckName',
          key: 'deckName',
          editable: true,
          inputType: 'deckSelect',
        },
        {
          title: t('players.points'),
          dataIndex: 'stagePoints',
          key: 'stagePoints',
          editable: true,
          inputType: 'number',
        }
      ];
      /* if (props.admin && !stage.isDone) {
        participantsCol = [
            {
              title: t('columns.position'),
              dataIndex: 'stagePlace',
              key: 'place',
              editable: false,
            },
            {
              title: t('players.name'),
              dataIndex: 'playerName',
              key: 'name', 
              editable: false,
              render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
            },
            {
              title:  t('decks.name'),
              dataIndex: 'deckName',
              key: 'deckName',
              editable: true,
              render: (state, record) => {
                if (record.deckId > 0 ) {
                  return (<Space> {record.deckName} 
                        <Link to={'/decks/'+record.deckId+'/'}>
                          <FolderViewOutlined style={{ fontSize: '25px' }} />
                        </Link>
                      </Space>);
                } 
                // return (<Space> {record.deckName}<FolderAddOutlined style={{ fontSize: '25px' }}/></Space>);
                if (props.hasRights && (props.hasRights.isAdmin || props.hasRights.isReferral)){
                  // console.warn('renderizzo adddecklist per player in pagina di tappa non chiusa:', record);
                  return (<Space> {record.deckName}<AddDecklist player={record} {...props}/></Space>);
                }
                return (<Space> {record.deckName} </Space>);
              }
            },
            {
              title: t('players.points'),
              dataIndex: 'stagePoints',
              key: 'stagePoints',
              editable: false,
            },
            {
              title: t('common.actions'),
              dataIndex: 'playerId',
              key: 'playerId',
              render: (state, record) => ((<Space><Button icon={<DeleteOutlined />} onClick={() => onDeletePlayer(record)}/>
                </Space>))
            }
        ];
      } else {
        participantsCol = [
          {
            title: t('columns.position'),
            dataIndex: 'stagePlace',
            key: 'place',
            editable: false,
          },
          {
            title: t('players.name'),
            dataIndex: 'playerName',
            key: 'name', 
            editable: false,
            render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
          },
          {
            title:  t('decks.name') ,
            dataIndex: 'deckName',
            key: 'deckName',
            editable: true,
            render: (state, record) => {
              if (record.deckId > 0 ) {
                return (<Space> {record.deckName} 
                      <Link to={'/decks/'+record.deckId+'/'}>
                        <FolderViewOutlined style={{ fontSize: '25px' }} />
                      </Link>
                    </Space>);
              }
              // return (<Space> {record.deckName}<AddDecklist player={record} {...props}/></Space>);
              if (props.hasRights && (props.hasRights.isAdmin || props.hasRights.isReferral)){
                // console.warn('renderizzo adddecklist per player in pagina di tappa chiusa:', record);
                return (<Space> {record.deckName}<AddDecklist player={record} {...props}/></Space>);
              }
              return (<Space> {record.deckName} </Space>);
            }
          },
          {
            title: t('players.points'),
            dataIndex: 'stagePoints',
            key: 'stagePoints',
            editable: false,
          },
        ];
      } */
    }
    

    useEffect(() => {
        setDataSource(props.dataSource)
    }, [props.dataSource])

    async function onDeletePlayer(participant) {
      // console.warn('arrivato alla chiamata ajax! ', participant)
      props.deletePlayer.mutate(participant)
      window.location.reload(false)
    }

    function onConfirm(event) {
      event.preventDefault();
      setModalActive(true);
    }

    async function onSave(event) {
        event.preventDefault()
        // alert("salvo la classifica!")
        // console.warn('params di rankingtable', props.tournament)
        let mo;
        if (props.isTournament) {
          mo = {
            stageId: props.tournament.data.payLoad.id,
            players: dataSource,
          }
        } else {
          mo = {
            stageId: props.stage.payLoad.id,
            players: dataSource,
          }
        }
        
        // console.warn('modello da salvare', mo)
        setModalActive(false);
        props.updateRanking.mutate(mo)
        props.toggleEditing(event)
    }

    const handleSave = (row) => {
        // console.warn('riga modificata:',row)
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.playerId === item.playerId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setDataSource(newData);
      };

    if (props.editing === false) {
        return (
            <Table 
            rowClassName={(record, index) => (index < 4 && (tournType != 4 && tournType != 5)) ? 'table-row-qualified' :  '' } 
            columns={generateParticipantsCol(props)}
            dataSource={dataSource}
            pagination={false}
            loading={props.participants && !props.participants.fulfilled && props.participants.pending}
          />
        )
    } else {
        const EditableRow = ({ index, ...props }) => {
            const [form] = Form.useForm();
            return (
              <Form form={form} component={false}>
                <EditableContext.Provider value={form}>
                  <tr {...props} />
                </EditableContext.Provider>
              </Form>
            );
          };
          
          const EditableCell = ({
            title,
            editable,
            inputType,
            children,
            dataIndex,
            record,
            handleSave,
            ...restProps
          }) => {
            const [editing, setEditing] = useState(false);
            const inputRef = useRef(null);
            const form = useContext(EditableContext);
            useEffect(() => {
              if (editing) {
                inputRef.current.focus();
              }
            }, [editing]);
          
            const toggleEdit = () => {
              setEditing(!editing);
              form.setFieldsValue({
                [dataIndex]: record[dataIndex],
              });
            };
          
            const save = async () => {
              try {
                const values = await form.validateFields();
                toggleEdit();
                handleSave({ ...record, ...values });
              } catch (errInfo) {
                console.log('Save failed:', errInfo);
              }
            };
          
            let childNode = children;
          
            if (editable) {
              /* childNode = editing ? (
                <Form.Item
                  style={{
                    margin: 0,
                  }}
                  name={dataIndex}
                  rules={[
                    {
                      required: true,
                      message: `${title} is required.`,
                    },
                  ]}
                >
                  <InputNumber ref={inputRef} onPressEnter={save} onBlur={save} />
                </Form.Item>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  style={{
                    paddingRight: 24,
                  }}
                  onClick={toggleEdit}
                >
                  {children}
                </div>
              ); */

              if (editing) {
                if (inputType === 'deckSelect') {
                  childNode = (
                    <Form.Item name="deckName">
                        <Select
                            ref={inputRef}
                            placeholder={t('decks.placeholder')}
                            value={selectedDeck}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                            onChange={save}
                            allowClear
                        >
                            {decknameOpts}
                        </Select>
                    </Form.Item>
                  );
                  return <td {...restProps}>{childNode}</td>;
                }
                if (inputType === 'number') {
                  childNode = (
                    <Form.Item
                      style={{
                        margin: 0,
                      }}
                      name={dataIndex}
                      rules={[
                        {
                          required: true,
                          message: `${title} is required.`,
                        },
                      ]}
                    >
                      <InputNumber ref={inputRef} onPressEnter={save} onBlur={save} />
                    </Form.Item>
                  );
                } else {
                  childNode = (
                    <Form.Item
                      style={{
                        margin: 0,
                      }}
                      name={dataIndex}
                      rules={[
                        {
                          required: true,
                          message: `${title} is required.`,
                        },
                      ]}
                    >
                      <Input ref={inputRef} onPressEnter={save} onBlur={save} />
                    </Form.Item>
                  );
                }
              } else {
                childNode = (
                  <div
                    className="editable-cell-value-wrap"
                    style={{
                      paddingRight: 24,
                    }}
                    onClick={toggleEdit}
                  >
                    {children}
                  </div>
                );
              }
            }
          
            return <td {...restProps}>{childNode}</td>;
          };

          const components = {
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          };

          const columns = participantsColEdit.map((col) => {
            if (!col.editable) {
              return col;
            }
        
            return {
              ...col,
              onCell: (record) => ({
                record,
                editable: col.editable,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
              }),
            };
          });
        
        if (props.showConfirm) {
          return (
              <>
                  <Row justify="center" style={{ marginBottom: '10px' }}>
                      <Col span={4}><Button type="primary" danger onClick={props.toggleEditing}>{t('common.cancel')}</Button></Col>
                      <Col span={4}><Button onClick={(event) => onConfirm(event)}>{t('common.save')}</Button></Col>
                  </Row>
                  <Modal title="Confirm Save" open={modalActive} onOk={(event) => onSave(event)} onCancel={() => setModalActive(false)} okText={t('common.confirm')} cancelText={t('common.cancel')}>
                      <p>By clicking OK, your changes will be saved and the stage will be closed.<br/> Continue?</p>
                  </Modal>
                  <Table
                      components={components}
                      rowClassName={() => 'editable-row'}
                      dataSource={dataSource}
                      columns={columns}
                      pagination={false}
                  />
              </>
              
          )
        }
        return (
          <>
                  <Row justify="center" style={{ marginBottom: '10px' }}>
                      <Col span={4}><Button type="primary" danger onClick={props.toggleEditing}>{t('common.cancel')}</Button></Col>
                      <Col span={4}><Button onClick={(event) => onSave(event)}>{t('common.save')}</Button></Col>
                  </Row>
                  <Table
                      components={components}
                      rowClassName={() => 'editable-row'}
                      dataSource={dataSource}
                      columns={columns}
                      pagination={false}
                  />
              </>
        )
    }
}

export default RankingTable;